import type { RouteRecordRaw } from 'vue-router'

/** Nechránené obrazovky. Prihlásenie má vlastný layout — bez shellu. */
export const authRoutes: RouteRecordRaw[] = [
	{
		path: '/prihlasenie',
		name: 'login',
		component: () => import('./LoginPage.vue'),
		meta: { titleSk: 'Prihlásenie' },
	},
	{
		path: '/nemate-opravnenie',
		name: 'forbidden',
		component: () => import('./ForbiddenPage.vue'),
		meta: { titleSk: 'Nemáte oprávnenie', requiresAuth: true },
	},
]
